import client from 'lib/apiClient';
const BASEURL = 'API/1_0/notes.php';

export const getNotes = (params) => client.get(BASEURL, { params });

export const saveNote = (data) => client.post(BASEURL, data);

export const deleteNote = (hash) => client.delete(BASEURL, { data: { hash } });

export const addCount = (hash, type) =>
  client
    .post(BASEURL, {
      hash,
      counter: type,
      change: '+1',
    })
    .catch((e) => e);
